<template>
    <div class=" header2 flex1">
        <!-- 新加条件筛选3 -->
        <div class="head-li v_status"  v-if="headData.condition3">
            <el-select v-model="vc_id" placeholder="分类筛选" @change="change_condition3">
                <el-option v-for="item in dataClassify" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nc_id }}</span> -->
                </el-option>
            </el-select>
        </div>

        <!-- 新加条件筛选13 -->
        <div class="head-li v_status"  v-if="headData.condition13">
            <el-select v-model="vc_id" placeholder="付款人" @change="change_condition13">
                <el-option v-for="item in payNameArr" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nc_id }}</span> -->
                </el-option>
            </el-select>
        </div>


        <!-- 新加条件筛选8 -->
        <div class="head-li"  v-if="headData.condition8" >
            <div class="block userTime2_dv">
                <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    value-format="timestamp"
                    @change="change_time2"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </div>
        </div>
        <!-- 新加条件筛选9 -->
        <div class="head-li v_status"  v-if="headData.condition9">
            <el-select v-model="v_paixu" placeholder="排序" @change="change_condition9">
                <el-option v-for="item in rankArr" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>
        </div>
        <!-- 新加条件筛选6 -->
        <div class="head-li v_status"  v-if="headData.condition6" >
            <el-select v-model="isrecommend" placeholder="是否推荐" @change="change_condition6">
                <el-option v-for="item in v_recommend_type" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>
        </div>
       
        <!-- 新加条件筛选11 -->
        <div class="head-li v_status "  v-if="headData.condition11" >
            <el-select v-model="is_shangxiajia" placeholder="上下架" @change="change_shangjia_status">
                <el-option v-for="item in shangjia_status" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>
        </div>
        <!-- 新加条件筛选12  章节状态-->
        <div class="head-li v_status "  v-if="headData.condition12" >
            <el-select v-model="chapter_status_str" placeholder="状态" @change="change_chapter_status">
                <el-option v-for="item in chapter_status" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>
        </div>
        <!-- 新加条件筛选2 -->
        <div class="head-li v_status "  v-if="headData.condition2" >
            <el-select v-model="is_tijiao" placeholder="状态" @change="change_tijiao_status">
                <el-option v-for="item in tijiao_status" :key="item.id" :label="item.name" :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                </el-option>
            </el-select>
        </div>
        <!-- 新加条件筛选1 请输入搜索内容-->
        <el-button  class="head-li" type="danger" size="mini" v-if="headData.del" @click="allDelFun">批量删除</el-button>
        <el-button  class="head-li" type="warning" size="mini" v-if="headData.condition1" @click="condition1">批量修改</el-button>
        <el-button  class="head-li" type="warning" size="mini" v-if="headData.condition10" @click="condition10">批量复制</el-button>
        <el-button class="head-li" type="primary" size="mini" v-if="headData.add" @click="tapAddFun">添加</el-button>
        <div class="seach_dv head-li" v-if="headData.search">
			<el-input
			  	@keyup.enter.native="SearchFun"
				:placeholder="headData.search_placeholder"
				v-model="seachAalue">
				<i slot="prefix" class="el-input__icon el-icon-search" @click="SearchFun"></i>
			</el-input>	
        </div>
        

        <!-- 新加条件筛选5 -->
        <div class="head-li"  v-if="headData.condition5" @click="condition5">
            <el-select v-model="v_region" placeholder="地区" @change="change_region">
                <el-option v-for="item in v_region_type" :key="item.id" :label="item.name" :value="item.name">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
                </el-option>
            </el-select>
        </div>
        
        <!-- 新加条件筛选7 -->
        <div class="head-li"  v-if="headData.condition7" @click="condition7">
            <el-select v-model="v_host" placeholder="是否热门" @change="change_host">
                <el-option v-for="item in v_host_type" :key="item.id" :label="item.name" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
                </el-option>
            </el-select>
        </div>
        <!-- 新加条件筛选4 -->
        <div class="head-li"  v-if="headData.condition4" @click="condition4">
            <div class="block">
                <el-date-picker
                    v-model="date"
                    align="right"
                    type="year"
                    @change="change_time"
                    value-format="yyyy"
                    placeholder="选择年">
                </el-date-picker>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
   props:['headData','dataClassify','payNameArr'],
    data() {
        return {
            
            seachAalue: "" ,           //搜索
            v_status:'',
            v_region:'',
            v_recommend:'0',
            v_paixu:'id',     //id:默认id;ypv:阅读量倒叙;search_num:搜索量倒叙;fabulous:收藏量倒叙
            isrecommend:'',   //是否推荐
            is_shangxiajia:'', //上下架
            vc_id:'',
            v_host:'',
            //是否为机器用户 0否 1是
            u_reboot: [
                {name: "是",id: 1},
                {name: "否",id: 0},
            ],

            is_tijiao:'',
            tijiao_status:[
                {name: "状态",id: ''},
                {name: "已提交",id: 1},
                {name: "未提交",id: 0},
            ],

            chapter_status_str:'',
            chapter_status:[
                {name: "状态",id: ''},
                {name: "正常",id: 1},
                {name: "异常",id: 0},
            ],

            shangjia_status:[
                // {name: "上下架",id:''},
                {name: "上架",id: '0'},
                {name: "下架",id: '1'},
            ],

            //排行榜 //id:默认id;ypv:阅读量倒叙;search_num:搜索量倒叙;fabulous:收藏量倒叙
            rankArr:[
                {name: "排序",id: 'id'},
                {name: "阅读量",id: 'ypv'},
                {name: "搜索量",id: 'search_num'},
                {name: "收藏量",id: 'fabulous'},
                // {name: "日点击榜",id: 1},
                // {name: "周点击榜",id: 2},
                // {name: "月点击榜",id: 3},
                // {name: "季点击榜",id: 4},
                // {name: "年点击榜",id: 5},
            ],
           
            //推荐
            v_recommend_type:[
                {name: "是否推荐",id: ''},
                {name: "是",id: '1'},
                {name: "否",id: '0'},
                // {name: "1级推荐",id: 1},
                // {name: "2级推荐",id: 2},
                // {name: "3级推荐",id: 3},
                // {name: "4级推荐",id: 4},
                // {name: "5级推荐",id: 5},
                // {name: "6级推荐",id: 6},
                // {name: "7级推荐",id: 7},
                // {name: "8级推荐",id: 8},
                // {name: "9级推荐",id: 9},
            ],
            //是否热门
            v_host_type:[
                {name: "全部",id: ''},
                {name: "否",id: 0},
                {name: "是",id: 1},
            ],
            //地区
            v_region_type: [
                {name: "不筛选",id: ''},
                {name: "大陆",id: 0},
                {name: "香港",id: 1},
                {name: "日本",id: 2},
                {name: "韩国",id: 3},
                {name: "美国",id: 4},
                {name: "德国",id: 5},
                {name: "英国",id: 6},
                {name: "台湾",id: 7},
                {name: "法国",id: 8},
                {name: "俄罗斯",id: 9},
                {name: "印度",id: 10},
                {name: "西班牙",id: 11},
                {name: "加拿大",id: 12},
                {name: "澳大利亚",id: 13},
                {name: "新加坡",id: 14},
                {name: "其它",id: 15},
            ],
            date: "",
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            
        }
        
    },
    created(){
        this.chapter_status_str = this.headData.condition12_status  
    },
    methods:{
        change_chapter_status(value){
            this.$emit('condition12',this.chapter_status_str)
        },
        //上下架状态
        change_shangjia_status(value) {
            this.condition11(value)
        },
        //提交状态
        change_tijiao_status(value) {
            this.condition2(value)
        },
        //分类
        change_condition3(value){
            this.condition3(value)
        },
        //地区筛选
        change_region(val){
            this.condition5(val)
        },
        //推荐筛选
        change_condition6(val){
            this.condition6(val)
        },
        //推荐筛选
        change_host(val){
            this.condition7(val)
        },
        //排序
        change_condition9(val){
            this.condition9(val)
        },

        //按照创建日期来搜索
        change_time2(val) {
            this.date = val;
            this.condition8(val)
            //调用父组件的方法--添加
        },
    

        //按照创建日期来搜索
        change_time(val) {
            this.date = val;
            this.condition4(val)
            //调用父组件的方法--添加
        },

        //促发添加的方法
        tapAddFun(){
            //调用父组件的方法--添加
            this.$emit('tapAddFun')
        },
        //搜索方法
        SearchFun(){
            //调用父组件的方法--搜索
            this.$emit('SearchFun',this.seachAalue)
        },
        //批量删除
        allDelFun(){
            this.$emit('allDelFun')
        },


        /**
         * 以下方法还没使用  ，如果要使用了，请添加注释，避免后面的同事更改了
         */
        //条件筛选1---评论也的批量一次
        condition1(){
            this.$emit('condition1')
        },
        //条件筛选2
        condition2(value){
            this.$emit('condition2',value)
        },
        //条件筛选3
        condition3(value){
            this.$emit('condition3',value)
        },
        //条件筛选4
        condition4(val){
            this.$emit('tapTimeFun',val)
        },
        //条件筛选5
        condition5(val){
            this.$emit('tapFegionFun',val)
        },
        //条件筛选6
        condition6(val){
            this.$emit('tapRecommendFun',val)
        },
        //条件筛选7
        condition7(val){
            this.$emit('tapHostFun',val)
        },
        //条件筛选8
        condition8(val){
            this.$emit('tapTime2Fun',val)
        },
        //条件筛选9
        condition9(val){
            this.$emit('condition9',val)
        },
        condition10(val){
            this.$emit('condition10',val)
        },
        //上下架状态筛选项
        condition11(val){
            this.$emit('condition11',val)
        },
        //付款人筛选
        change_condition13(val){
            this.$emit('condition13',val)   
        }
    }
}

</script>
<style lang="scss" scoped>
.userTime2_dv{
    width: 352px!important;
}
.head-li{
    margin-left:10px;
}
.header2 {
    min-width:1200px;
	padding-top:15px;
	box-sizing: border-box;
	width: 100%;
	height: 60px;
	border-bottom: 1px solid #f2f2f2;
	//justify-content: flex-end;
	::v-deep .el-page-header__left {
		color: #aaaaaa;
	}
  ::v-deep .el-page-header__left::after {
    background-color: transparent;
  }
  .title {
    font-size: 18px;
    color: #4f7da4;
  }
  .add {
      margin-left:10px;
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 6px;
    color: #ffffff;
    background: #4f7da4;
	 cursor: pointer;
	 margin-left:10px;
  }
  .seach_dv{
	  margin-left:10px;
  }
}

.v_status{
    width:100px;
}

.block {
    width: 290px;
}
</style>
